import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const faqs = [
    {
      question: 'What are lifetime docs and post-incorporation maintenance?',
      answer: 'These include ongoing compliance support, charter amendments, NDAs, foreign qualifications, and more, ensuring your business remains in good standing.'
    },
    {
      question: 'Do I need a lawyer for incorporation?',
      answer: 'No, our assisted service eliminates the need for expensive legal consultations. However, if you need legal advice, our partners offer an optional attorney collaboration portal.'
    },
    {
      question: "What's included in the incorporation service?",
      answer: 'Entity formation (Delaware C-Corp), EIN application (Employer Identification Number), Bank account setup, Registered agent services, Founder stock issuance, and Lifetime documentation & compliance support.'
    },
    {
      question: "What's the difference between various incorporation platforms?",
      answer: 'Different platforms offer different features. Some are best for founders needing flexibility in share issuance, add-ons like SAFEs and stock plans, while others focus on ease of use and comprehensive support.'
    },
    {
      question: 'How long does the incorporation process take?',
      answer: 'The incorporation process typically takes 1-2 weeks from start to finish, including document preparation, filing, and receiving your official incorporation documents.'
    },
    {
      question: 'What ongoing support does Trueledger provide after incorporation?',
      answer: 'We offer post-incorporation maintenance services, including compliance tracking, bookkeeping assistance, and tax filing support for US entities. We also provide connections to specialized partners for specific needs.'
    },
    {
      question: 'Can I change my incorporation structure later?',
      answer: 'Yes, but it can be complex and costly. We recommend carefully considering your business goals and consulting with our team to choose the right structure from the start.'
    },
    {
      question: 'Do you provide bookkeeping services?',
      answer: 'Yes! Trueledger offers comprehensive bookkeeping services for US startups and SMBs. Our team of experienced bookkeepers ensures your financial records are accurate and up-to-date, helping you stay compliant and make informed business decisions.'
    }
  ];

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-gray-900">
          FAQs
        </h2>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`} className="bg-white rounded border border-stone-200 shadow-sm">
              <AccordionTrigger className="px-6 py-4 text-left hover:no-underline">
                <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-4">
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;